/* eslint-disable react/no-unescaped-entities */
// import useGetCurrentUser from '@/services/api/auth/useGetCurrentUser'
import Buttons from './Buttons'
import InputFieldsDemo from './InputFieldsDemo'
import DropDownMenuDemo from '@/pages/playground/DropDownMenuDemo'
import Table from './Table'
import useAppStore from '@/store/useAppStore'
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card'
import { Button, ButtonText } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import { TextField } from '@/components/ui/TextField'
import ButtonGroupPlayground from '@/pages/playground/ButtonGroup'
import SimpleComboBox from '@/components/SimpleComboBox'
import { useState } from 'react'
import { Description } from '@/components/ui/Description'
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { PlusIcon, XMarkIcon } from '@heroicons/react/16/solid'
import { Separator } from '@/components/ui/separator'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'
import { Toggle } from '@/components/ui/toggle'
import { Switch } from '@/components/ui/switch'
import {
  Tooltip,
  TooltipTrigger,
  TooltipProvider,
  TooltipPortal,
  TooltipContent,
  TooltipArrow,
} from '@/components/ui/tooltip'
import { toast } from 'sonner'

export default function PlaygroundPage() {
  // const { data } = useGetCurrentUser()

  const count = useAppStore((state) => state.count)
  const inc = useAppStore((state) => state.increment)
  const dec = useAppStore((state) => state.decrement)

  const items = [
    {
      value: 'valnext.js',
      label: 'LNext.js',
    },
    {
      value: 'valsveltekit',
      label: 'LSvelteKit',
    },
    {
      value: 'valnuxt.js',
      label: 'LNuxt.js',
    },
    {
      value: 'valremix',
      label: 'LRemix',
    },
    {
      value: 'valastro',
      label: 'LAstro',
    },
  ]

  // const s = items.find((item) => item.value === 'next.js')

  const [showConfirmation, setShowConfirmation] = useState(false)

  const [selected, setSelected] = useState(
    items.find((item) => item.value === 'valnext.js'),
  )

  return (
    <div className="p-5 text-xs">
      <div className="m-2">
        <p className="mb-4">Toast</p>
        <Button
          onClick={() =>
            toast.success('Hello world this is a testing toast!', {
              duration: 500000,
            })
          }
        >
          Show toast
        </Button>

        <Button onClick={() => toast.error('Hello world!')}>
          Show error toast
        </Button>
      </div>
      <div className="m-2">
        <p className="mb-4">Tooltip</p>
        <div className="flex gap-4">
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button iconOnly>
                  <PlusIcon />
                </Button>
              </TooltipTrigger>
              <TooltipPortal>
                <TooltipContent align="end">
                  Label
                  <TooltipArrow />
                </TooltipContent>
              </TooltipPortal>
            </Tooltip>
          </TooltipProvider>
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button iconOnly>
                  <PlusIcon />
                </Button>
              </TooltipTrigger>
              <TooltipPortal>
                <TooltipContent side="bottom" align="start">
                  Label
                  <TooltipArrow />
                </TooltipContent>
              </TooltipPortal>
            </Tooltip>
          </TooltipProvider>
        </div>
      </div>
      <Separator />
      <p className="mb-4">Switch</p>
      sm
      <div className="flex gap-4">
        <Switch />
        <Switch checked />
        <Switch disabled />
        <Switch disabled checked />
      </div>
      lg
      <div className="flex gap-4">
        <Switch size="large" />
        <Switch size="large" checked />
        <Switch size="large" disabled />
        <Switch size="large" disabled checked />
      </div>
      <hr className="my-2" />
      {/* ------------ */}
      <p>Toggle</p>
      <Toggle value="one" size="sm">
        Hello
      </Toggle>
      <hr className="my-2" />
      <p className="mb-4">Toggle Group</p>
      <ToggleGroup type="multiple">
        <ToggleGroupItem value="one">one</ToggleGroupItem>
        <ToggleGroupItem value="two">two</ToggleGroupItem>
        <ToggleGroupItem value="three">three</ToggleGroupItem>
      </ToggleGroup>
      <hr className="my-4" />
      <p className="mb-4">TABS</p>
      <Tabs defaultValue="account" className="w-[400px]">
        <TabsList>
          <TabsTrigger value="account">Account</TabsTrigger>
          <TabsTrigger value="password">Password</TabsTrigger>
        </TabsList>
        <TabsContent value="account">
          Make changes to your account here.
        </TabsContent>
        <TabsContent value="password">Change your password here.</TabsContent>
      </Tabs>
      <hr className="my-4" />
      <div className="">
        <p>Un controlled Modal window</p>
        <Dialog>
          <DialogTrigger asChild>
            <Button>Open Form Modal</Button>
          </DialogTrigger>
          <DialogContent className="md:max-w-[800px]">
            <DialogHeader>
              <DialogTitle>Custom Transaction Repeat</DialogTitle>
              <DialogClose>
                <XMarkIcon />
              </DialogClose>
            </DialogHeader>
            <Separator className="" />
            <DialogBody className="">
              <div>
                <div className="grid grid-cols-4 items-center justify-start gap-4">
                  <label htmlFor="name" className="text-left">
                    Name
                  </label>
                  <input
                    id="name"
                    defaultValue="Pedro Duarte"
                    className="col-span-3"
                  />
                </div>
                <div className="h-[900px]-- grid grid-cols-4 items-end gap-4">
                  <label htmlFor="username" className="text-right">
                    Username
                  </label>
                  <input
                    id="username"
                    defaultValue="@peduarte"
                    className="col-span-3"
                  />
                </div>
              </div>
            </DialogBody>
            <Separator className="" />
            <DialogFooter className="">
              <DialogClose asChild>
                <Button type="button" variant="secondary">
                  Close
                </Button>
              </DialogClose>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <hr />
      <p>Controlled Modal confirmation</p>
      <div>
        <Button onClick={() => setShowConfirmation(true)}>
          Show confirmation Modal
        </Button>
        {/* ---------------- */}
        <Dialog open={showConfirmation} onOpenChange={setShowConfirmation}>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>Are you sure you want to close?</DialogTitle>
              <DialogClose>
                <XMarkIcon />
              </DialogClose>
            </DialogHeader>

            <DialogBody>
              <p>
                You have unsaved changes in the "Edit Vault" form. If you close
                this window, all entered data will be lost. Are you sure you
                want to proceed?
              </p>
            </DialogBody>

            <DialogFooter>
              <DialogClose asChild>
                <Button type="button" variant="destructive">
                  Close without saving
                </Button>
              </DialogClose>
              <Button variant="secondary">Close</Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
      <p>Combobox</p>
      <div className="w-[400px]">
        <SimpleComboBox
          items={items}
          selected={selected}
          setSelected={setSelected}
          getOptionLabel={(item) => (
            <div>
              <p>{item.label}</p>
              <Description>Description</Description>
            </div>
          )}
          getSelectedLabel={(item) => item.label}
          getValue={(item) => item.value}
          clearable
        />
      </div>
      <div className="my-4 w-[400px]">
        <p className="my-2">with text field</p>
        <TextField>
          <TextField.Label>Combo11</TextField.Label>
          <SimpleComboBox
            items={items}
            selected={selected}
            setSelected={setSelected}
            getOptionLabel={(item) => (
              <div>
                <p>{item.label}</p>
                <Description>Description</Description>
              </div>
            )}
            getSelectedLabel={(item) => item.label}
            getValue={(item) => item.value}
            clearable
          />
        </TextField>
      </div>
      <div className="my-4 w-[400px]">
        <p className="my-2">with text field</p>
        <TextField status="error" statusText="Status Text">
          <TextField.Label>Combo22</TextField.Label>
          <SimpleComboBox
            items={items}
            selected={selected}
            setSelected={setSelected}
            getOptionLabel={(item) => (
              <div>
                <p>{item.label}</p>
                <Description>Description</Description>
              </div>
            )}
            getSelectedLabel={(item) => item.label}
            getValue={(item) => item.value}
            clearable
          />
        </TextField>
      </div>
      <div>
        PlaygroundPage |||| {count}
        <TextField
          status="error" //{errors?.dateAsOf ? 'error' : ''}
          statusText="xxxxxxxxxx" //{errors?.dateAsOf?.message ?? null}
        >
          <TextField.Label>Date as of </TextField.Label>
        </TextField>
        <button type="button" onClick={() => inc(1)}>
          +
        </button>
        <button type="button" onClick={() => dec(1)}>
          -
        </button>
      </div>
      <Table />
      <ButtonGroupPlayground />
      <Buttons />
      <hr className="my-4" />
      <DropDownMenuDemo />
      <InputFieldsDemo />
      <h2>CArd</h2>
      <div className="my-4 flex justify-center">
        <Card className="place-self-center">
          <CardHeader>
            <CardTitle>Reset your password</CardTitle>
          </CardHeader>
          <CardContent>
            <p>
              Enter the email address associated with your account and we'll
              send you a link to reset your password.
            </p>
            <form className="mt-4 grid gap-3">
              <div>
                <TextField>
                  <TextField.Label>Email</TextField.Label>
                  <TextField.Input placeholder="example@gmail.com" />
                </TextField>
              </div>

              <button className="hidden" type="submit">
                submit
              </button>
            </form>

            <div className="mt-7">
              <Button type="submit" size="lg" className="w-full">
                <ButtonText>Continue</ButtonText>
              </Button>
              <p className="mt-4 text-center text-base text-txt-secondary">
                <Link
                  to="/login"
                  className="text-center text-txt-secondary no-underline"
                >
                  Return to sign in
                </Link>
              </p>
            </div>
          </CardContent>
          <CardFooter>Footer</CardFooter>
        </Card>
      </div>
    </div>
  )
}
